import { APP_INITIALIZER } from '@angular/core';
import { ReplaceableComponentsService } from '@abp/ng.core';
import { eAccountComponents } from '@abp/ng.account';
import { RegisterComponent } from './register/register.component';

/**
 * Replaces ABP's register screen with ours, which will not submit until the terms have been
 * accepted. The backend refuses an unaccepted registration whatever the client, so this is
 * about showing people the document rather than about enforcement.
 */
export const REGISTER_COMPONENT_PROVIDER = {
  provide: APP_INITIALIZER,
  useFactory: (replaceableComponents: ReplaceableComponentsService) => () => {
    replaceableComponents.add({
      key: eAccountComponents.Register,
      component: RegisterComponent,
    });
  },
  deps: [ReplaceableComponentsService],
  multi: true,
};
